import React, { useCallback } from "react";
import { withRouter } from "react-router";
import app from "./base";
import { render } from "react-dom";
import {Component} from "react";
import backBanner from "./backBanner.jpg"
import logoParkvillegreens from "./logoParkvillegreens.png"

const project_code = "parkville_greens_erin_gates";
var userEmail;
var userPhoneNumber = " ";
var userName = " ";


class SignupPage extends Component{


  componentDidMount(){
    console.log("SIGNUP PAGE COMPONENT DID MOUNT");

    const autoFillEmail = () => {
      var currentHref = window.location.href;
      var splitter = currentHref.split("?");
  
      if(splitter.length > 1){
  
        var splitIt = splitter[1].split("=");
        var splitAgain = splitIt[1].split("_split_");
        console.log("split again " + splitAgain);
  
        if(splitAgain[1] !== "ADMIN"){
          var userAppRef = app.database().ref('/client_appointments/' + project_code + "/" + splitAgain[0] + "/users").child(splitAgain[1]);
    
          userAppRef.once('value', snapshot => {
    
            console.log(snapshot);
            userEmail = snapshot.val().email;
            userName = snapshot.val().fullName;
            userPhoneNumber = snapshot.val().phoneNumber;
    
            try{
            var nameElement = document.getElementById("fullName");
            nameElement.innerHTML = userName;
            var nameTextTitle = document.getElementById("nameTextTitle");
            nameTextTitle.innerHTML = "Your Name"
            //console.log(userEmail);
            var emailElement = document.getElementById("userEmail");
            emailElement.value = userEmail;
            } catch (error) {
              alert(error);
            }
    
          });
        }
      }
  
  
    }
  
    autoFillEmail();
  }

}

const SignUp = ({ history }) => {
  const handleSignUp = useCallback(async event => {
    event.preventDefault();
    const { email, password } = event.target.elements;
    var checkboxBool = document.getElementById("privacyAccept").checked

    if(password.value.length > 7 && checkboxBool === true){
      if(password.value.includes("1") || password.value.includes("2")
        || password.value.includes("3") || password.value.includes("4")
        || password.value.includes("5") || password.value.includes("6")
        || password.value.includes("7") || password.value.includes("8")
        || password.value.includes("9") || password.value.includes("0")){

    
        try {
          await app
            .auth()
            .createUserWithEmailAndPassword(email.value, password.value);

            var currentHref = window.location.href;
            var splitter = currentHref.split("?");
            var toRedirect = "/";
            if(splitter.length > 1){
              toRedirect = toRedirect + "?" + splitter[1];
            }
            //need to push user id

            var idToUse = app.auth().currentUser.uid;

            var userPost = app.database().ref('/users/' + idToUse);
            console.log("phone number " + userPhoneNumber);

            userPost.set({
              email: email.value,
              phoneNumber: userPhoneNumber,
              fullName: userName,
              avatarCode: "undefined",
              project_code: project_code
            });

          history.push(toRedirect);
        } catch (error) {
          alert(error);
        }
      }
      else{
        var errorEle2 = document.getElementById("errorMessage");
        errorEle2.innerHTML = "Password must be at least 8 characters, and have one number";
      }
    }
    else{
      if(password.value.length < 7){
        var errorEle = document.getElementById("errorMessage");
        errorEle.innerHTML = "Password must be at least 8 characters, and have one number";
      }
      if( checkboxBool === false){
        var errorEle3 = document.getElementById("errorMessage");
        errorEle3.innerHTML = "Must accept privacy policy to make an account";
      }
    }
  }, [history]);


  const goToLogin = () =>{
    var currentHref = window.location.href;
    var splitter = currentHref.split("?");
    var toRedirect = "/";
    if(splitter.length > 1){
      toRedirect = toRedirect + "login?" + splitter[1];
    }
    else{
      toRedirect = "/login"
    }
  
    var startRef = currentHref.split("/signup");
    var newRef = startRef[0] + toRedirect;
  
    console.log("going to "+newRef);
    window.location = newRef;
  }

  const openTermsAndService = () =>{
    window.open("https://www.kavtek.com/privacy-policy/");
  }

  var signUpPage = new SignupPage();

  signUpPage.componentDidMount();

  return (
    <>
      <div>
        <img className="BackBanner" src={backBanner} alt="Banner" />;
        <img className="parkLogo" src={logoParkvillegreens} alt="Logo" />;
      </div>
      <div className="BlackFrontOverlay">
        <h2 className="blackBoxTitle">Sign up</h2>
        <p className="paragraphReg" id="errorMessage"></p>
        <form onSubmit={handleSignUp}>
        <p className="GreenTitle" id="nameTextTitle"></p>
        <p className="paragraphReg" id="fullName">{userName}</p>
          <label className="GreenTitleLabel">
            Email
            <br></br>
            <input id="userEmail" name="email" type="email" placeholder="Email" />
          </label>
          <label className="GreenTitleLabel">
            Password
            <br></br>
            <input name="password" type="password" placeholder="Password" />
          </label>
          <input type="checkbox" id="privacyAccept" className="acceptPrivacy"></input>
          <span className="privacyText">I have read and accept the</span><button type="button" className="signOutButton" onClick={()=>{openTermsAndService();}}>Privacy Policy</button><br></br>
          <button type="button" className="signOutButton" onClick={()=>{goToLogin();}}>Have an Account? Sign in</button>
          <button className="joinMeetingButton" type="submit">Sign Up</button>
        </form>
      </div>
    </>
  );
};




export default withRouter(SignUp);
